/* clamp accepts a number `n` and two inclusive bounds, and will return `n`
 * if it is with in the bounds, or the boundary nearest to the number if it
 * is not.
 * @param n The number to clamp
 * @param max The inclusive upper bound to clamp to
 * @param min The inclusive lower bound to clamp to
 */
const clamp = (n, max, min) => {
  if (n < min) return min;
  if (n > max) return max;
  return n;
};

/* formatNumber accepts a number and an options object and returns a
 * formatted version as a string
 * @param number: number; The number to format
 * any two values in a series; used to calculate the precision when rounding
 */
const formatNumber = (number) => {
  let n = number;
  let l = null; //may be set to a string indicating the magnitude ie "k", "m", etc
  //determine the suffix of the number based on its magnitude
  if (number >= 1e3) {
    let cases = [
      { sentinel: 1e3, suffix: "k" },
      { sentinel: 1e6, suffix: "m" },
      { sentinel: 1e9, suffix: "b" },
      { sentinel: 1e12, suffix: "t" },
    ];
    for (let i = 0; i < cases.length; i++) {
      let { sentinel, suffix } = cases[i];
      let reduced = number / sentinel;
      if (reduced < 1e3) {
        n = reduced;
        l = suffix;
        break;
      }
    }
  }
  // stringify number, fix decimals longer than 2, strip double 0's and single trailing 0
  if (l !== null) {
    n = ((n * 100) | 0) / 100;
    n = n.toFixed(1);
    return `${n}${l}`;
  }
  return n.toString();
};

/* withSymbol accepts a string and a symbol, and will add the symbol to the
 * input appropriately.
 * ex: withSymbol("12", "$") => "$12"
 * ex: withSymbol("100.0", "USD") => "100 USD"
 * @param input: string; the text to be formatted
 * @param symbol: string; indicates the type of format to apply
 * @returns string;
 */
const withSymbol = (input, symbol) => {
  //modify the value of `n` based on the value of `format`
  switch (symbol) {
    case "$":
      input = `$${input}`;
      break;
    case "USD":
      input = `${input} USD`;
      break;
    case "%":
      input = `${input}%`;
      break;
    default:
    /* do not apply formatting */
  }
  return input;
};

export { clamp, formatNumber, withSymbol };
